import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")


  export const listUsers = async (startDate, endDate,farmId,sectionId,lotId,userId,type) => {
  const params = {startDate,endDate,farmId,lotId,sectionId,userId,role:type };
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "tracking/user-list-track",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};
  
  
  export const deleteTrackMovement = async (params) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "tracking/delete-track-movement",
      config
    );
    const res = response.data || null;
    return res;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};
  
  




export default {
 listUsers,
 deleteTrackMovement
};
